import { makeStyles } from "@mui/styles"
import Button from '../common/Button'
import classNames from 'classnames'

// import ChatBox from "../common/ChatBox"

const useStyles = makeStyles((theme) => ({
    footerRoot: {
        height: '5rem',
        backgroundColor: theme.palette.greyLightOne,
        width: '100vw',
        maxWidth: '100%',
        position: 'fixed',
        bottom: '0',
        right: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    footerBackButton: {
        paddingLeft: '5%'
    },
    footerNextButton: {
        display: 'flex',
        columnGap: '2rem',
        alignItems: 'center',
        paddingRight: '5%'
    },  
    '@media (max-width: 1000px)': {
        footerRoot: {
            height: '4rem',
        },
        footerChatBox: {
            display: 'none'
        },
        footerBackButton: {
            top: '33%'
        }
    }
}))

function Footer({
    handleBackPage,
    onSubmit,
    isDisable,
    buttonText,
    className
    // isChatBoxAvailable
}) {

    const classes = useStyles()
    return (
        <>
            <div className={classNames( classes.footerRoot, className) }>
                <div className={classes.footerBackButton}>
                    {handleBackPage &&
                        <Button
                            transparent
                            onClick={handleBackPage}>
                            Back
                        </Button>}
                </div>
                <div className={classes.footerNextButton}>
                    <Button disable={!isDisable} onClick={onSubmit} >{buttonText}</Button>
                    {/* {!isChatBoxAvailable && <ChatBox className={classes.footerChatBox} />} */}
                </div>
            </div>
        </>
    )
}

export default Footer
